import EmployeesSelect from './employees-select';

export default EmployeesSelect;
